/**
 * rooms filter - used for filtering rooms from the rooms specificed as the query string parameter
 */
angular.module('bookingApp').filter('filterRooms',['$filter', function(){
    var roomsFilter = function(input, roomsToFilter){
        var out = [];
        var count = 0;
        angular.forEach(input, function(room){
            if(typeof room.nonFilteredIndex === 'undefined') {
                room.nonFilteredIndex = count;
            }
            if(roomsToFilter.length > 0){
                angular.forEach(roomsToFilter, function(roomToFilter){
                    if(room.bookable.id === parseInt(roomToFilter)){
                        out.push(room);
                    }
                });
            } else {
                out.push(room);
            }
            count++;
        });
        return out;
    };
    return roomsFilter;
}]);
